import React, { useEffect, useState } from 'react';
import AdminLayout from '../../../components/layout/AdminLayout';
import ReconTypeForm from '../../../components/forms/ReconTypeForm';
import { useReconTypeApi } from '../../../hooks/useReconTypeApi';
import { useNavigate, useParams } from 'react-router-dom';
import { ReconTypeDTO } from '../../../services/apiClient';

const ReconTypeEdit: React.FC = () => {
  const { getById, edit } = useReconTypeApi();
  const [entityData, setEntityData] = useState<ReconTypeDTO | null>(null);
  const [isSubmitting, setIsSubmitting] = useState<boolean>(false);
  const { id } = useParams<{ id: string }>();
  const navigate = useNavigate();

  const breadcrumbs = [
    { label: 'Admin', href: '#' },
    { label: 'Recon Types', href: '/admin/recontypes' },
    { label: 'Edit', href: '#' },
  ];

  useEffect(() => {
    const fetchEntityData = async () => {
      try {
        const response = await getById(id!);
        setEntityData(response?.data || null);
      } catch (error) {
        console.error('Error fetching ReconType data:', error);
      }
    };

    fetchEntityData();
  }, [id]);

  const handleSubmit = async (data: any) => {
    try {
      setIsSubmitting(true);
      await edit(id!, data);
      navigate('/admin/recontypes');
    } catch (error) {
      console.error('Error updating ReconType:', error);
    } finally {
      setIsSubmitting(false);
    }
  };

  return (
    <AdminLayout
      activeMenuItem="/admin/recontypes"
      breadcrumbs={breadcrumbs}
      allowedRoles={['Admin']}
      requiredPermission="Settings.ReconType.Edit"
    >
      {entityData ? (
        <ReconTypeForm
          initialValues={entityData}
          onSubmit={handleSubmit}
          onCancel={() => navigate('/admin/recontypes')}
          isLoading={isSubmitting}
        />
      ) : (
        <p>Loading...</p>
      )}
    </AdminLayout>
  );
};

export default ReconTypeEdit;
